export default "__VITE_ASSET__45fc2387__"